var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"mt-n2 mr-n1",attrs:{"fab":"","dark":"","small":"","color":_vm.colour},on:{"click":function($event){return _vm.cb()}}},[_c('v-icon',[_vm._v(_vm._s(_vm.mdi))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }